import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { CardBody } from "reactstrap";
import {
  OrderDetailsModalLayoutJSON,
  OrderEditDetailsModalLayoutJSON,
} from "../Json/OrderDetailsLayoutJSON";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { OrdersEditDetailModalFieldsJSON } from "../Json/OrderDetailsFieldsJSON";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAllAg,
  getAllCustomer,
  getAllProduct,
  getAllRelationshipManager,
} from "../OrderService";
import { KYC_ALLOWED_OEM_IDS } from "../OrderUtils";
import useOrderDetails from "../Hook/useOrderDetails";
import { getOrgId } from "../../../../Utils/CommonUtils";
import {
  setDetailsFieldJson,
  setEditDetailsFieldJson,
  setRmName,
} from "../../../../slices/orders/orderSlice";
import {
  resetFormState,
  setSelectValidError,
} from "../../../../slices/common/reducer";
import { useState } from "react";

function Details() {
  const dispatch = useDispatch();
  const formState = useSelector((state) => state.common.formRendererState);
  const params = useParams();
  const editMode = !!params.id;
  const detailsFieldJson = useSelector(
    (state) => state.order.selectedOrders.detailsFieldJson
  );
  const editDetailsFieldJson = useSelector(
    (state) => state.order.selectedOrders.editDetailsFieldJson
  );
  const { id } = useParams();
  const activeTabs = useSelector(
    (state) => state.order.selectedOrders.activeTabs
  );
  const customerData = useSelector((state) => state.order.customerData);
  const rmName = useSelector((state) => state.order.rmName);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );
  const userInfo = useSelector(
    (state) => state.common.userInfo
  );
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState
  );
  // const [rmName, setRmName] = useState("");

  const currentOemId = Number(
    detailsData?.oem_id ||
    formState?.oem_id ||
    detailsData?.insurance_company_id ||
    formState?.insurance_company_id
  );
  const isFgOrder = KYC_ALLOWED_OEM_IDS.includes(currentOemId);

  const baseLayoutJSON = editMode
    ? OrderEditDetailsModalLayoutJSON
    : OrderDetailsModalLayoutJSON;

  const fieldsJSON = editMode ? editDetailsFieldJson : detailsFieldJson;

  const isRenewalOrder =
    String(formState?.order_type || "").toLowerCase() === "renewal";

  const isKycField = (el) =>
    el.elementid === "1718617035556" || el.elementid === 1718617035556;

  const isRenewalOnlyField = (el) =>
    Object.keys(fieldsJSON || {}).some(
      (k) =>
        k.startsWith(`${el.elementid}-`) &&
        fieldsJSON[k]?.["display-yes"] === "order_type"
    );

  // Drop hidden columns (KYC for non-FG, renewal fields for fresh orders) and
  // the rows left empty, so they don't leave blank gaps in the layout
  const isHiddenField = (el) =>
    (!isFgOrder && isKycField(el)) || (!isRenewalOrder && isRenewalOnlyField(el));

  const layoutJSON = baseLayoutJSON.map((section) => ({
    ...section,
    child: (section.child || [])
      .map((columns) => ({
        ...columns,
        child: (columns.child || []).filter(
          (col) => !col.child?.some(isHiddenField)
        ),
      }))
      .filter((columns) => columns.child.length > 0),
  }));

  // const organizationId = getOrgId();

  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  };

  useEffect(() => {
    return () => {
      dispatch(setRmName(""));
    };
  }, [dispatch]);

  useEffect(() => {
    if (!editMode && selectedUser.organizationid) {
      const fetchProductAndCustomer = async () => {
        try {
          // Fetch AG data
          const agResponse = await getAllAg(selectedUser.organizationid);
          const currentDate = getCurrentDate();

          // Update detailsFieldJson with AG data
          const updatedDetailsFieldJsonWithAg = {
            ...detailsFieldJson,
            "1718616984561-customSelect": {
              ...detailsFieldJson["1718616984561-customSelect"],
              "data-customvalue": agResponse,
            },
            "1718616970411-customDate": {
              ...detailsFieldJson["1718616970411-customDate"],
              value: currentDate,
            },
          };

          dispatch(setDetailsFieldJson(updatedDetailsFieldJsonWithAg));
          if (formState.ag_id) {
            const customerResponse = await getAllCustomer(
              "AGRP",
              formState.ag_id
            );

            const updatedDetailsFieldJsonWithCustomer = {
              ...updatedDetailsFieldJsonWithAg,
              "1718616976561-customSelect": {
                ...updatedDetailsFieldJsonWithAg["1718616976561-customSelect"],
                "data-customvalue": customerResponse,
              },
            };

            dispatch(setDetailsFieldJson(updatedDetailsFieldJsonWithCustomer));

            // Fetch Product data if both ag_id and product_type are selected
            if (formState.product_type && formState.ag_id) {
              const productResponse = await getAllProduct(
                formState.ag_id,
                formState.product_type
              );

              const updatedDetailsFieldJsonWithProduct = {
                ...updatedDetailsFieldJsonWithCustomer,
                "1718617002793-customSelect": {
                  ...updatedDetailsFieldJsonWithCustomer[
                  "1718617002793-customSelect"
                  ],
                  "data-customvalue": productResponse,
                },
              };

              dispatch(setDetailsFieldJson(updatedDetailsFieldJsonWithProduct));
            }
          }
        } catch (error) {
          console.error("Error fetching product or customer data:", error);
        }
      };

      fetchProductAndCustomer();
    }
  }, [
    editMode,
    selectedUser.organizationid,
    selectedUser.owner_id,
    formState.ag_id,
    formState.customer_id,
    formState.product_type,
  ]);

  useEffect(() => {
    if (editMode && selectedUser.organizationid) {
      const fetchProductAndCustomer = async () => {
        try {
          if (formState.ag_id) {
            const customerResponse = await getAllCustomer(
              "AGRP",
              formState.ag_id
            );

            const isCustomerSelectEnabled =
              detailsData?.status === "PAYMENT_SUCCESS" || detailsData?.status === "COMPLETED";

            const updatedDetailsFieldJsonWithCustomer = {
              ...editDetailsFieldJson,
              "1718616984561-customSelect": {
                ...editDetailsFieldJson["1718616984561-customSelect"],
                "data-customvalue": customerResponse,
                "display-disabled": isCustomerSelectEnabled ? 1 : 0,
              },
              "1718617031258-customSelect": {
                ...editDetailsFieldJson["1718617031258-customSelect"],
                "display-disabled": isCustomerSelectEnabled ? 1 : 0,
              },
            };
            dispatch(
              setEditDetailsFieldJson(updatedDetailsFieldJsonWithCustomer)
            );
          }
        } catch (error) {
          console.error("Error fetching product or customer data:", error);
        }
      };

      fetchProductAndCustomer();
    }
  }, [
    editMode,
    selectedUser.organizationid,
    formState.ag_id,
    formState.customer_id,
    detailsData,
  ]);

  useEffect(() => {
    if (formState.customer_id) {
      getAllRelationshipManager(formState.customer_id);
    }
  }, [formState.customer_id]);

  const [isReset, setIsReset] = useState(false);

  useEffect(() => {
    if (!formState.ag_id) {
      // Only update the state if the "data-customvalue" is not already reset
      if (
        detailsFieldJson["1718616976561-customSelect"]?.["data-customvalue"]
          ?.length > 0
      ) {
        const updatedDetails = {
          ...detailsFieldJson,
          "1718616976561-customSelect": {
            ...detailsFieldJson["1718616976561-customSelect"],
            "data-customvalue": [], // Reset the dropdown value
          },
        };

        // Dispatch the update if necessary
        dispatch(setDetailsFieldJson(updatedDetails));
      }
      if (
        detailsFieldJson["1718617002793-customSelect"]?.["data-customvalue"]
          ?.length > 0
      ) {
        const updatedDetailsWithProductReset = {
          ...detailsFieldJson,
          "1718617002793-customSelect": {
            ...detailsFieldJson["1718617002793-customSelect"],
            "data-customvalue": [], // Reset product dropdown value
          },
        };
        dispatch(setDetailsFieldJson(updatedDetailsWithProductReset));
      }
    }
  }, [formState.ag_id, detailsFieldJson, dispatch]);

  useOrderDetails(id, {
    enabled: !!(editMode && id),
  });

  // const detailsData = useSelector(
  //   (state) => state.order.selectedOrders.detailsData
  // );
  // const isCustomerSelectEnabled = detailsData?.status === "PAYMENT_PENDING";
  // OrdersEditDetailModalFieldsJSON["1718616984561-customSelect"][
  //   "display-disabled"
  // ] = !isCustomerSelectEnabled ? 1 : 0;

  // useEffect(() => {
  //   if (!detailsData) return;

  //   const isCustomerSelectEnabled = detailsData?.status === "PAYMENT_PENDING";

  //   const updatedFieldsJSON = {
  //     ...editDetailsFieldJson,
  //     ["1718616984561-customSelect"]: {
  //       ...editDetailsFieldJson["1718616984561-customSelect"],
  //       "display-disabled": !isCustomerSelectEnabled ? 1 : 0,
  //     },
  //   };

  //   dispatch(setEditDetailsFieldJson(updatedFieldsJSON));
  // }, []);

  return (
    <div>
      <Form>
        <CardBody>
          {layoutJSON.map((element) => (
            <div key={element.elementid}>
              {element.child.map((child) =>
                renderElement(child, fieldsJSON, formState)
              )}
            </div>
          ))}
          {!editMode && (
            <Row>
              <Form.Group as={Col} className="col-md-6">
                <Form.Label className="rm_name">
                  Relationship Manager
                </Form.Label>
                <Form.Control
                  type="text"
                  // placeholder="Enter"
                  name="rmName"
                  id="rmName"
                  value={rmName}
                  disabled
                />
              </Form.Group>
            </Row>
          )}
        </CardBody>
      </Form>
    </div>
  );
}

export default Details;
